export default __webpack_public_path__ + "static/yishuo-bffa42f27c8498a1f078b584277fcf80.png";